<script lang="ts">
    import { closeModal } from 'svelte-modals';
    import { _ } from 'svelte-i18n';
    import ButtonMain from '../ButtonMain.svelte';
    import Button from '../../components/Vehicles/Button.svelte';
    import ButtonBack from '../ButtonBack.svelte';
    import MessageInline from '../Messages/MessageInline.svelte';
    import TemplateRow from '../TemplateRow.svelte';
    import ButtonRemove from '../ButtonRemove.svelte';

    export let isOpen: boolean = false;
    export let component: any;
    export let componentProps: any;
    export let width: number | null = null;
    export let height: number | null = null;

    export let onClick: () => void = () => {};

    let styles: string[] = [];
    if (width) {
        styles.push('width: ' + width + 'px');
    } else {
        styles.push('width: auto');
    }
    if (height) {
        styles.push('height: ' + height + 'px');
    } else {
        styles.push('height: auto');
    }
</script>

{#if isOpen}
    <div role="dialog" class="modal">
        <div class="contents" style={styles.join(';')}>
            <svelte:component this={component} {componentProps} />

            <div class="actions">
                <ButtonMain
                    text={$_('OK')}
                    on:click={() => {
                        closeModal();
                        onClick();
                    }}
                />
            </div>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1002;

        /* allow click-through to backdrop */
        pointer-events: none;
    }

    .contents {
        width: 890px;
        height: 630px;
        max-width: 95vw;
        max-height: 95vh;
        border-radius: 6px;
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        pointer-events: auto;
        font-size: 14px;
        padding: 30px;
        /*border: 3px solid var(--automapa-blue);*/
        box-shadow:
            0 0 0 10px #1c5dc722,
            0 4px 8px rgba(0, 0, 0, 0.2);
    }

    .actions {
        margin-top: 32px;
        display: flex;
        justify-content: center;
        column-gap: 10px;
    }
</style>
